export default __webpack_public_path__ + "static/media/pixels-project-6.baffdfb1.webp";